import React from 'react';
import { FooterV2, useSegment } from '@sparknz/journeys-common';

import { EditorModePlaceholder } from 'shared/components';
import { usePageConfig } from 'shared/providers';
import { FooterProps } from './FooterEditConfig';

const Footer: React.FC<FooterProps> = ({
  footerId = 'online-shop/footer-menu',
  footerVariation = '',
  isInEditor,
}) => {
  const { segment } = useSegment();
  const { apiBaseUrl } = usePageConfig();

  const NON_SEGMENT_VARIATIONS = ['large_business_govt', 'about_spark'];
  const variation = NON_SEGMENT_VARIATIONS.includes(footerVariation)
    ? footerVariation
    : segment;

  if (isInEditor) {
    return (
      <EditorModePlaceholder
        label={`Footer in editor mode with: ${JSON.stringify({ footerId })}`}
      />
    );
  }
  return <FooterV2 apiBaseUrl={apiBaseUrl} variation={variation} />;
};

export default Footer;
